/**
 * DOM Selectors which are used either in pollinators or other scripts
 * outside this repo and should be updated/cleaned up in those consumers
 * before changing here.
 * Ex – `INPUT_NAME_<..>`, `TEST_ID_<..>`, `ID_<...>`, `CLASSNAME_<...>`
 */
export const SELECTORS = Object.freeze({
  /** Name of the app install dialog in emcee, used in pollinators */
  TEST_ID_APP_INSTALL_DIALOG: 'marketplace-app-install-dialog',
  TEST_ID_CMT_SECTION_MESSAGE: 'marketplace-app-cmt-section-message'
});